import { useTranslation } from 'react-i18next';

const MainPdfImage = ({
  loading,
  mainScreenshot,
}: {
  loading: boolean;
  mainScreenshot: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="border-b border-stroke px-7 py-4 dark:border-strokedark">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-black dark:text-white">{t('labels.mainScreenshot')}</h3>
        </div>
      </div>

      <div className="p-7">
        {loading ? (
          <div className="flex items-center justify-center p-7">
            <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
          </div>
        ) : !mainScreenshot ? (
          <div className="text-gray-500 text-center text-sm">{t('labels.noMainScreenshotsFound')}</div>
        ) : (
          <div key={mainScreenshot} className="relative">
            <iframe
              src={mainScreenshot}
              style={{
                height: '100%',
                width: '240px',
                border: 'none',
                pointerEvents: 'none',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MainPdfImage;
